import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { ROLL_API, getRollById, updateRollByStock, updateStockRoll } from '../../api/rollApi';
import { toast } from 'react-toastify';
import { useApiProgress } from '../../hooks/ApiProgress';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import useFirstRender from '../../hooks/FirstRender';
import { PRODUCT_PATH, getPageProducts } from '../../api/productApi';
import { LOCATION_PATH, getPageLocations } from '../../api/locationApi';
import Input from '../../components/Input';
import { onChange } from '../../utils/functions';
import ProductPicker from '../../components/product/ProductPicker';
import LocationPicker from '../../components/location/LocationPicker';
import Button from '../../components/Button';

const StockEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const { id } = useParams();
    const closeTab = useCloseTab()
    const [roll, setRoll] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${ROLL_API}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${ROLL_API}`, false)

    const onClickSubmit = () => {
        const body = {
            id,
            upc: roll.upc,
            productId: roll.product?.id,
            quantity: roll.quantity,
            restQuantity: roll.restQuantity,
            locationId: roll.location?.id,
            boilerCode: roll.boilerCode,
            unitCost: roll.unitCost,
            date: roll.date
        }
        updateRollByStock(id, body).then(res => {
            closeTab()
            toast.success('Stok güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    const [productPage, setProductPage] = useState({
        content: []
    });
    const pendingApiCallProduct = useApiProgress('get', `${PRODUCT_PATH}/page`, false)
    const [productQuery, setProductQuery] = useState('')
    const [searchTimerProduct, setSearchTimerProduct] = useState();
    const searchingProduct = async (params) => {
        if (searchTimerProduct) clearTimeout(searchTimerProduct);
        let timer = setTimeout(() => {
            getPageProducts(params)
                .then(res => {
                    setProductPage(res.data)
                })
        }, 500);
        setSearchTimerProduct(timer);
    }
    const onClickLoadMoreProduct = () => {
        if (!productPage.last) {
            loadProducts({ search: productQuery, lastId: productPage.content[productPage.content.length - 1]?.id })
        }
    }
    const loadProducts = (params) => {
        !pendingApiCallProduct &&
            getPageProducts(params)
                .then(res => {
                    setProductPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }

    const [locationPage, setLocationPage] = useState({
        content: []
    });

    useEffect(() => {
        !isFirstRender && searchingProduct({ search: productQuery })
    }, [productQuery])

    const [locationQuery, setLocationQuery] = useState('')
    const [searchTimerLocation, setSearchTimerLocation] = useState();
    const pendingApiCallLocation = useApiProgress('get', `${LOCATION_PATH}/page`, false)
    const searchingLocation = async (params) => {
        if (searchTimerLocation) clearTimeout(searchTimerLocation);
        let timer = setTimeout(() => {
            getPageLocations(params)
                .then(res => {
                    setLocationPage(res.data)
                })
        }, 500);
        setSearchTimerLocation(timer);
    }
    const onClickLoadMoreLocation = () => {
        if (!locationPage.last) {
            loadLocations({ search: locationQuery, lastId: locationPage.content[locationPage.content.length - 1]?.id })
        }
    }
    const loadLocations = (params) => {
        !pendingApiCallLocation &&
            getPageLocations(params)
                .then(res => {
                    setLocationPage(prevState => ({ ...res.data, content: prevState.content.concat(res.data.content) }))
                })
    }
    useEffect(() => {
        !isFirstRender && searchingLocation({ search: locationQuery })
    }, [locationQuery])

    useEffect(() => {
        loadProducts({ size: 20 })
        loadLocations({ size: 20 })
    }, [])

    useEffect(() => {
        getRollById(id).then(res => setRoll(res.data))
    }, [id])

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Stok Düzenle</label>
                <Input
                    label='Barkod'
                    name='upc'
                    type='number'
                    placeholder='Barkod no girin...'
                    error={errors.upc}
                    value={roll.upc}
                    onChange={e => onChange(e, setRoll, setErrors)}
                    disabled
                />
                <ProductPicker
                    label='Ürün'
                    pendingApiCall={pendingApiCallProduct}
                    state={roll.product}
                    setState={(value) => setRoll(prevState => ({ ...prevState, product: value }))}
                    query={productQuery}
                    setQuery={setProductQuery}
                    error={errors.productId}
                    page={productPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, productId: undefined }))}
                    onClickClear={() => setRoll(prevState => ({ ...prevState, product: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreProduct()}
                />
                <Input
                    label='Miktar(m)'
                    name='quantity'
                    type='number'
                    placeholder='Miktar girin...'
                    error={errors.quantity}
                    value={roll.quantity}
                    onChange={e => onChange(e, setRoll, setErrors)}
                />
                <Input
                    label='Kalan(m)'
                    name='restQuantity'
                    type='number'
                    placeholder='Kalan miktar girin...'
                    error={errors.restQuantity}
                    value={roll.restQuantity}
                    onChange={e => onChange(e, setRoll, setErrors)}
                />
                <LocationPicker
                    label='Lokasyon'
                    pendingApiCall={pendingApiCallLocation}
                    state={roll.location}
                    setState={(value) => setRoll(prevState => ({ ...prevState, location: value }))}
                    query={locationQuery}
                    setQuery={setLocationQuery}
                    error={errors.locationId}
                    page={locationPage}
                    setErrors={() => setErrors(prevState => ({ ...prevState, locationId: undefined }))}
                    onClickClear={() => setRoll(prevState => ({ ...prevState, location: undefined }))}
                    onClickLoadMore={() => onClickLoadMoreLocation()}
                />
                <Input
                    label='Kazan No'
                    name='boilerCode'
                    placeholder='Kazan no girin...'
                    error={errors.boilerCode}
                    value={roll.boilerCode}
                    onChange={e => onChange(e, setRoll, setErrors)}
                />
                <Input
                    label='Birim Maliyet (USD/m)'
                    name='unitCost'
                    type='number'
                    placeholder='Birim maliyet girin...'
                    error={errors.unitCost}
                    value={roll.unitCost}
                    onChange={e => onChange(e, setRoll, setErrors)}
                />
                <Input
                    label='Tarih'
                    type='date'
                    name='date'
                    placeholder='Birim maliyet girin...'
                    error={errors.date}
                    value={roll.date}
                    onChange={e => onChange(e, setRoll, setErrors)}
                />
            </div>
            <div className='flex justify-center'>
                <Button
                    text='Kaydet'
                    variant='green'
                    onClick={onClickSubmit}
                />
            </div>
        </div>
    )
}

export default StockEditPage